import { Link } from 'react-router-dom';
import type { V2Pillars } from './content';

export function Pillars({ content }: { content: V2Pillars }) {
  return (
    <section className="v2-section v2-pillars">
      <div className="v2-container">
        <div className="v2-section-head">
          <span className="v2-eyebrow" data-reveal>
            {content.eyebrow}
          </span>
          <h2 className="v2-h2" data-reveal data-reveal-delay="0.08">
            {content.title} <em className="v2-serif-accent">{content.accent}</em>
          </h2>
          <p className="v2-body" data-reveal data-reveal-delay="0.16">
            {content.body}
          </p>
        </div>

        <div className="v2-pillar-list">
          {content.pillars.map((pillar, index) => (
            <article className={`v2-pillar ${index % 2 === 1 ? 'v2-pillar-flip' : ''}`} key={pillar.number}>
              <div className="v2-pillar-copy" data-reveal>
                <span className="v2-pillar-number" aria-hidden="true">
                  {pillar.number}
                </span>
                <span className="v2-eyebrow">{pillar.eyebrow}</span>
                <h3 className="v2-h3">{pillar.title}</h3>
                <p className="v2-body">{pillar.body}</p>
                <ul className="v2-checklist" data-reveal-group>
                  {pillar.items.map((item) => (
                    <li key={item}>
                      <i className="ph ph-check" aria-hidden="true" />
                      {item}
                    </li>
                  ))}
                </ul>
                <Link to={pillar.link.href} className="v2-textlink">
                  {pillar.link.label}
                  <i className="ph ph-arrow-right" aria-hidden="true" />
                </Link>
              </div>

              <div className="v2-pillar-media" data-reveal data-reveal-delay="0.1" data-parallax-scope>
                <div className="v2-pillar-shot">
                  <img src={pillar.image} alt={pillar.imageAlt} loading="lazy" data-parallax="-0.07" />
                </div>
                <span className="v2-pillar-chip">
                  <i className="ph ph-lightning" aria-hidden="true" />
                  {pillar.chip}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
